import icon1 from "@/assets/band-1.svg.asset.json";
import icon2 from "@/assets/band-2.svg.asset.json";
import icon3 from "@/assets/band-3.svg.asset.json";
import icon4 from "@/assets/band-4.svg.asset.json";

const items: { icon: string; main: string; accent: string }[] = [
  { icon: icon1.url, main: "Surgery If You\nTruly Need It.", accent: "No Fazool Tests" },
  { icon: icon2.url, main: "Surgeons Who Listen.\nNurses Who Care.", accent: "Always By Your Side" },
  { icon: icon3.url, main: "Fixed Price. Confirmed\non Admission.", accent: "In Writing" },
  { icon: icon4.url, main: "Admission, Discharge,\nFollow-up", accent: "- All Planned" },
];

export function PromiseBand({ alts }: { alts?: string[] }) {
  return (
    <section className="bg-background">
      <div className="mx-auto max-w-7xl px-4 py-8 lg:px-8 lg:py-10">
        <div className="rounded-3xl bg-primary-soft/70 px-4 py-6 sm:px-8 sm:py-7">
          <ul className="grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-x-6">
            {items.map((it, i) => (
              <li key={it.main} className="flex items-center gap-5">
                <div className="flex h-20 w-20 shrink-0 items-center justify-center rounded-2xl bg-white shadow-[0_4px_14px_-4px_rgba(15,23,42,0.15)] sm:h-[84px] sm:w-[84px]">
                  <img
                    src={it.icon}
                    alt={alts?.[i] ?? ""}
                    aria-hidden={alts?.[i] ? undefined : true}
                    width={60}
                    height={60}
                    className="h-14 w-14 object-contain sm:h-[60px] sm:w-[60px]"
                    loading="lazy"
                  />
                </div>
                <p className="whitespace-pre-line text-[14px] font-semibold leading-snug text-foreground sm:text-[15px]">
                  {it.main}
                  {"\n"}
                  <span className="font-semibold text-brand-red">{it.accent}</span>
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
